module.exports = __webpack_public_path__ + "static/media/baner-podcasty-desktop.eaeaf254.jpg";